import "./WarningIcon.css";

function WarningIcon() {
  return (
    <svg
      class="App-warning-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        class="stroke-path"
        d="M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0z"
        stroke="white"
      ></path>
      <path class="stroke-path" d="M12 8v4" stroke="white"></path>
      <path class="stroke-path" d="M12 16h.01" stroke="white"></path>
    </svg>
  );
}

export default WarningIcon;
